export default [
  'https://www.nerdwallet.com/cdn/landing-pages/thecount/coin-1-2x.png',
  'https://www.nerdwallet.com/cdn/landing-pages/thecount/coin-2-2x.png',
  'https://www.nerdwallet.com/cdn/landing-pages/thecount/coin-3-2x.png',
  'https://www.nerdwallet.com/cdn/landing-pages/thecount/star-1-2x.png',
];
